import React from 'react'

import Sidebar from './Sidebar';
import { useState, useEffect } from 'react';
import { useParams, } from 'react-router-dom'
const SinglPro = () => {
    let { id } = useParams();
    const [post, setpost] = useState([])
    const img = "https://webeetec.com/itsharks24/blog/admin/";
    useEffect(() => {
        fetch("https://webeetec.com/itsharks24/blog/api/singlepost.php?id=" + id)
            .then(r => r.json())
            .then((r) => {
                console.log(r);
                setpost(r);
            }
            )
    }, [id])
    return (
        <>
            <section className="container">
                <div className="wrapper clear">

                    {
                        post.map((post) => {




                            return (

                                <div className="contentLeft">
                                    <div className="singlePostMeta">
                                        <div className="singlePostTime">{post.date}</div>
                                        <h1>{post.category}</h1>
                                        <a href="#" className="singlePostCategory">{post.title}</a>
                                    </div>
                                    <div className="singlePostWrap">
                                        <div className="singlePostImg">
                                            <img src={img + post.image} alt="Francoise img" />
                                        </div>
                                        <p>Lorem ipsum dolor sit amet, <a href="#">big group of colleagues</a> consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident.</p>

                                    </div>





                                </div>
                            )
                        })
                    }


                    <Sidebar/>




                </div>

                <div className="clear"></div>

            </section>






        </>
    )
}

export default SinglPro